import { useNavigate } from 'react-router-dom';


import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import CheckImage from '../../assets/icons/checkImage.svg'
import { useEffect } from 'react';



export default function CongratulationsPage() {
    const navigate = useNavigate()

    setTimeout(() => {
        navigate('/enter-new-password')
    },2000)

    return (
        <Box sx={{
            width: '80%',
            backgroundColor: '#FFF',
            borderRadius: '30px',
            border: '1px solid #60A5DC',
            margin: 'auto',
            marginTop: '40px',
            padding: '70px 0'
        }}
        >
            
            {/* <Typography level="h3" sx={{ padding: '0 10%', color: '#231F20', fontSize: '30px', marginBottom: '30px' }}>هل نسيت كلمة المرور ؟</Typography> */}
            {/* <Typography level="p" sx={{ padding: '0 10%', color: '#434448', fontSize: '16px' }}>أدخل عنوان البريد الإلكتروني الخاص بك وسوف تتلقى رابط لإعادة تعيين كلمة المرور الخاصة بك</Typography> */}

            <Stack spacing={5} 
            sx={{ 
                width: '80%',
                margin: '50px auto', 
                display:'flex',
                textAlign:'center',
                alignItems:'center' 
                }}>
            <img className='congratulationsImage' src={CheckImage} alt='Congratulations' />
            <Typography level="p" sx={{ padding: '0 10%', color: '#434448', fontSize: '14px', marginBottom: '30px' }}>تم إرسال الرسالة إلى الرقم الذي قدمته. يرجى التحقق من الرسائل وإدخال رمز التحقق (OTP) للمتابعة. شكراً!</Typography>


                {/* <Button
                    sx={{ height: '60px', backgroundColor: '#3E64F4', color: '#FFF', fontSize: '20px', borderRadius: '30px' }}
                >إرسال كود تعيين كلمة السر</Button> */}
            </Stack>
        </Box>
    )
}